import Field from "@arcgis/core/layers/support/Field";

const observationFields = [{
    name: "cuttingRealizationPractices",
    type: "string"
},
{
    name: "document.collectionId",
    type: "string"
},
{
    name: "gathering.eventDate.begin",
    type: "string"
},
{
    name: "gathering.eventDate.end",
    type: "string"
},
{
    name: "gathering.interpretations.coordinateAccuracy",
    type: "double"
},
{
    name: "unit.linkings.taxon.id",
    type: "string"
},
{
    name: "unit.unitId",
    type: "string"
},
{
    name: "unit.unitId",
    type: "string"
},
{
    name: "declarationArrivalDate",
    type: "string"
},
{
    name: "notificationObjectId",
    type: "string"
},
{
    name: "standNumber",
    type: "string"
},
{
    name: "isRadius",
    type: "double"
},
{
    name: "clashRadius",
    type: "double"
},
{
    name: "id",
    type: "string"
}].map(f => f as Field);

export default observationFields;